<button
  (click)="editShift()"
  nz-button
  nzType="default"
  class="w-100 fw-normal"
  [disabled]="disabled"
  data-test-id="wilson-timeline-shift-form-edit-button"
>
  <fa-icon [icon]="faPenToSquare"></fa-icon>
</button>
